import {connect} from 'react-redux';
import CommentReplies, {CommentRepliesProps} from './CommentReplies';
import CommentModel from '../../types/CommentModel';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState, ownProps: CommentRepliesContainerProps): Partial<CommentRepliesProps> => {
   return {
      parentComment: ownProps.parentComment,
      commentReplies: ownProps.commentReplies,
      isEditable: ownProps.isEditable,
      hasFocus: ownProps.hasFocus,
      currentUserId: state.currentUserId,
      isSelected: ownProps.isSelected,
      onSelect: ownProps.onSelect
   };
};

export default connect(mapStateToProps, null)(CommentReplies);

interface CommentRepliesContainerProps {
   parentComment: CommentModel;
   commentReplies: CommentModel[];
   isEditable: boolean;
   hasFocus?: boolean;
   isSelected: boolean;
   onSelect(): void;
   onBlur?(): void;
   addReply(text: string): Promise<any>;
}
